export enum WovenLabelStitchType {
  TwoCorner = "2-corner",
  FourCorner = "4-corner",
  TwoSide = "2-side",
}
